import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";

// For an action that changes the page rather than going to another one, and
// is secondary enough to look like a link. Use Link for anything with a URL.
const StyledLinkButton = styled.button`
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  color: var(--juno-color-link);
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: var(--juno-color-link-hover);
  }

  &:focus-visible {
    outline: var(--juno-focus-outline-width) solid var(--juno-color-focus);
    outline-offset: var(--juno-focus-outline-offset);
  }

  &[aria-disabled="true"] {
    color: var(--juno-color-text-secondary);
    cursor: default;
  }
`;

const LinkButton = ({ children, ...props }) => (
  <StyledLinkButton type="button" {...props}>
    {children}
  </StyledLinkButton>
);

LinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default LinkButton;
